var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85516 1.74756C9.16247 1.75194 9.45561 1.87757 9.67073 2.09709L11.8844 4.31078C12.1039 4.52589 12.2296 4.81903 12.2339 5.12635V11.0684C12.2339 11.3774 12.1112 11.6737 11.8927 11.8922C11.6742 12.1107 11.3779 12.2335 11.0688 12.2335H2.91315C2.60414 12.2335 2.3078 12.1107 2.0893 11.8922C1.8708 11.6737 1.74805 11.3774 1.74805 11.0684V2.91266C1.74805 2.60365 1.8708 2.30731 2.0893 2.08881C2.3078 1.87031 2.60414 1.74756 2.91315 1.74756H8.85516Z",
    stroke: "white",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90362 12.2336V8.15579C9.90362 8.00129 9.84225 7.85312 9.733 7.74387C9.62375 7.63462 9.47558 7.57324 9.32107 7.57324H4.66067C4.50617 7.57324 4.358 7.63462 4.24875 7.74387C4.1395 7.85312 4.07812 8.00129 4.07812 8.15579V12.2336",
    stroke: "white",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 1.74756V4.07776C4.07812 4.23226 4.1395 4.38043 4.24875 4.48968C4.358 4.59893 4.50617 4.66031 4.66067 4.66031H8.73852",
    stroke: "white",
    strokeWidth: 1.1651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2afb01c6daea4054e2e7ff2b9db46184.svg";
export { ForwardRef as ReactComponent };